export const MINUTE_IN_SECONDS = 60;
export const HOUR_IN_MINUTES = 60;
export const HOUR_IN_SECONDS = 60 * MINUTE_IN_SECONDS;
export const QUARTER_HOUR_TO_HOUR_RATIO = 0.25;
export const QUARTER_HOUR_IN_MINUTES = HOUR_IN_MINUTES * QUARTER_HOUR_TO_HOUR_RATIO;
